import React from 'react'
import clsx from 'clsx'
import {ProgressLine} from 'uikit'
import {useAppSelector} from 'store'
import {
  getProgress,
  getAnsweredIds,
  getCountRiddles,
  getIsFullProgress,
} from 'store/game/selectors'
import kubok from 'src/img/kubok_min.png'
import styles from './GameProgress.scss'

export const GameProgress= () => {
  const isFullProgress = useAppSelector(getIsFullProgress)
  const progress = useAppSelector(getProgress)
  const count = useAppSelector(getCountRiddles)
  const answeredIdsCount = useAppSelector(getAnsweredIds).length
  const message = `${answeredIdsCount} / ${count}`
  const congratulateMessage = (
    <>
      <img src={kubok} className={styles.gtimage} />
      {message}
      <img src={kubok} className={styles.gtimage} />
    </>
  )

  return (
    <ProgressLine
      progress={progress}
      message={isFullProgress ? congratulateMessage : message}
      classNameProgress={clsx(isFullProgress && styles.fullProgress)}
    />
  )
}
